import React, { useEffect, useState } from "react";

import classes from "./MenuBar.module.css";
import Button from "../UI/Button";
import { useAuth } from "../../accounts/AuthProvider";
import { adminRequest } from "../../accounts/adminApi";
import Submenu from "./Submenu";
import { useNavigate, useLocation } from "react-router-dom";

const MenuBar = ({ page }) => {
  const navigate = useNavigate();
  const { configured, session } = useAuth();
  const { pathname } = useLocation();
  const [isBurgerMenu, setIsBurgerMenu] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const accessToken = session?.access_token;

  const burgerWidth = 940;
  useEffect(() => {
    const onResize = () => setIsBurgerMenu(window.innerWidth < burgerWidth);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    let active = true;
    setIsAdmin(false);
    if (!configured || !accessToken) return () => { active = false; };

    adminRequest(accessToken, "check-access")
      .then(result => {
        if (typeof result.isAdmin !== "boolean") {
          throw new Error("The administrator access response was invalid.");
        }
        if (active) setIsAdmin(result.isAdmin);
      })
      .catch(error => {
        if (active) {
          setIsAdmin(false);
          console.error("Could not verify administrator menu access.", error);
        }
      });
    return () => { active = false; };
  }, [configured, accessToken]);

  const resumeEditor = () => {
    setIsOpen(false);
    if (page !== "home") navigate("/");
  };

  const onLoadCurrentPage = (event) => {
    setIsOpen(false);
    const url = `/${event.currentTarget.id}`;
    if (pathname !== url) navigate(url);
  };

  const selectedAttr = { backgroundColor: "#258", color: "white" };
  const normalAttr = { backgroundColor: "white", color: "black" };

  const homeState =
    page === "home" ? selectedAttr : normalAttr;
  const libraryState = page === "library" ? selectedAttr : normalAttr;
  const supportState = page === "support" ? selectedAttr : normalAttr;
  const trainingState = page === "training" ? selectedAttr : normalAttr;
  const fretboardState = page === "fretboard" ? selectedAttr : normalAttr;
  const metronomeState = page === "metronome" ? selectedAttr : normalAttr;
  const blogState = page === "blog" ? selectedAttr : normalAttr;

  // for the Burger Menu Button
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const menuItems = (
    <>

      <Button onClick={resumeEditor} style={homeState}>
        Create Scale Charts
      </Button>
      <Submenu isBurger={isBurgerMenu} title={"Training..."}>
        <Button id="training" style={trainingState} onClick={onLoadCurrentPage}>
          Ear Training
        </Button>
        <Button id="fretboard" style={fretboardState} onClick={onLoadCurrentPage}>
          Fretboard Training
        </Button>
        <Button id="metronome" style={metronomeState} onClick={onLoadCurrentPage}>
          Metronome
        </Button>
      </Submenu>
      <Button id="library" style={libraryState} onClick={onLoadCurrentPage}>
        Library
      </Button>
      <Button id="blog" style={blogState} onClick={onLoadCurrentPage}>
        Blog
      </Button>
      {configured && session && <Button id="my-charts" style={page === "my-charts" || pathname === "/library/my-charts" ? selectedAttr : normalAttr} onClick={onLoadCurrentPage}>My Charts</Button>}
      {configured && session && isAdmin && <Button id="admin" style={page === "admin" ? selectedAttr : normalAttr} onClick={onLoadCurrentPage}>Admin</Button>}
      {configured && <Button id="account" style={page === "account" ? selectedAttr : normalAttr} onClick={onLoadCurrentPage}>
        {session ? "Account" : "Sign in"}
      </Button>}
      <Button id="support" style={supportState} onClick={onLoadCurrentPage}>
        Support Me
      </Button>

    </>
  );

  return (
    <>
      <header className={classes.header}>
        {isBurgerMenu && (
          <button
            type="button"
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
            className={`${classes["burger-menu"]} ${
              isOpen ? classes.open : ""
            }`}
            onClick={toggleMenu}
          >
            <div className={classes.bar}></div>
            <div className={classes.bar}></div>
            <div className={classes.bar}></div>
          </button>
        )}
        {isBurgerMenu === false && (
          <div className={classes.buttonContainer}>{menuItems}</div>
        )}
      </header>
      {isBurgerMenu === true && isOpen === true && (
        <div className={classes.mobileButtonContainer}>{menuItems}</div>
      )}
    </>
  );
};

export default MenuBar;
